export const breadcrumb = {
  title: 'Коллтрекинг',
  number: {
    index: 'Список номеров'
  },
  integration: {
    index: 'Интеграция'
  }
};
